// src/pages/Examiner/ExaminerReports.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Container, Alert, Spinner } from 'react-bootstrap';
import TitleWithBack from '../../components/common/TitleWithBack';

function ExaminerReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    axios
      .get('/api/examiner/reports')
      .then((response) => {
        setReports(response.data);
        setLoading(false);
      })
      .catch((err) => {
        setError('Error fetching reports.');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Container className="mt-3 text-center">
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  if (error) {
    return <Alert variant="danger" className="mt-3">{error}</Alert>;
  }

  return (
    <Container className="mt-2">
      <TitleWithBack title="Examiner Reports" level="h2" />
      <p>Below is the list of generated examiner reports. Click the download link to view the full report.</p>
      {reports.length === 0 ? (
        <Alert variant="info">Nothing to show here</Alert>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Report ID</th>
              <th>Exam Series</th>
              <th>Examiner Name</th>
              <th>Module</th>
              <th>Date</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {reports.map((report) => (
              <tr key={report.id}>
                <td>{report.id}</td>
                <td>{report.series}</td>
                <td>{report.examiner}</td>
                <td>{report.module}</td>
                <td>{new Date(report.date).toLocaleDateString()}</td>
                <td>
                  <a href={report.downloadUrl} target="_blank" rel="noopener noreferrer">
                    Download PDF
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Container>
  );
}

export default ExaminerReports;
